<p-autoComplete
    [(ngModel)]="selectedItem"
    [dropdown]="true"
    [suggestions]="filteredItems"
    (onSelect)="onSelectItem($event)"
    (completeMethod)="filterItems($event)"
    optionLabel="name"
    appendTo="body" 
    showClear="true"
    (onClear)="onClear()" 
    [ngClass]="{ 'placeholder-color': moduleName === 'change_review_grid' }"
    [placeholder]="placeholder" />
